/* eslint-disable import/no-internal-modules */

import { memoize } from 'lodash';
import moment from 'moment';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { DueDate } from 'components/atoms/due-date';
import { NoValue } from 'components/organisms/tasks/field-value';
import { DueDateValue } from './due-date-value-getter';

export const dueDateRenderer = memoize(
  (value?: DueDateValue): string => {
    return renderToStaticMarkup(
      value?.dueDate == null ? (
        <NoValue />
      ) : (
        <DueDate
          timestamp={moment(value.dueDate)}
          completed={value.completedAt != null}
        />
      ),
    );
  },
  (value?: DueDateValue) => `${value?.dueDate}, ${value?.completedAt}`,
);
